<template v-if="widgetReady">
    <ac-modal :title="'Select a Member'" :size-class="'modal-lg'" ref="modalRef">
            <template>
                <table ref="grid" class="mdl-data-table table table-responsive dataTable no-footer dtr-inline" width="100%">

                </table>
            </template>
    </ac-modal>
</template>                
                
<script>
import { api } from "../../global/framework/api.js";
import {formatter} from "../../global/formatter.js";
import {common} from "../../global/common.js";    
export default {
    name: "UserSelectionModal",
    data(){
        return {
            grid: null,
            widgetReady: false,
        }
    },
    methods: {
        async showModal({ providerEntityId: providerEntityId }) {
            let self = this;
            let data = await api.getData('ProviderEntity', providerEntityId, 'GetPatientsAndMembersOfProvidersMediator');

            if (self.grid !== null) {
                common.reloadGrid(self.grid, data);
                return;
            }

            this.grid = $(this.$refs.grid).DataTable({
                responsive: true,
                data: data,
                order: [[1, "asc"]],
                select: true,
                columns: [
                    {
                        title: "Select", data: null, render(data, type, row) {
                            return '<ac-button class="btn-sm btn-success wl-btn-success button-size" style="cursor:pointer;">SELECT</ac-button>';
                        }
                    },
                    {
                        title: "Full Name", data: "fullName",
                    },
                    {
                        title: "DOB", data: "birthDate", 
                        render: function (data) { return formatter.formatRawDateSort(data, true); }
                    },
                    {
                        title: "Company", data: 'company'
                    }
                ],
                drawCallback: function (settings) {
                    $(self.$refs.grid).off('click', 'tbody tr').on('click', 'tbody tr', function (e) {
                        let rowData = common.getRowData(this, self.grid);
                        self.$bus.$emit(self.$AcEvents.INVOICE_CONSUMER, rowData);
                        self.$refs.modalRef.close();
                    });
                },
                displayLength: 10,
            });

            this.widgetReady = true;
            this.$refs.modalRef.open();
        }
    }
}
</script>